<template>
  <div class="valid">
    <span class="label">学习有效期：</span>
    <span v-if="course.valid_end_time >= 0 && isValid">
      <span v-if="course.valid_type == 1">长期有效</span>
      <template v-else>
        <span v-if="course.valid_end_days < 0">
          <span>{{ course.valid_end_time | tsFormat('yyyy/MM/dd') }}截止</span>
          <TooltipEx
            v-if="course.valid_type != 1"
            class="tooltipex"
            contentClass="tooltip-help"
            :delay="0"
          >
            <img class="help" src="@/assets/images/course/help@2x.png" />
            <template v-slot:content> 购买后，在此日期前，学员可进行学习 </template>
          </TooltipEx>
        </span>
        <template v-else>
          <span>{{ course.valid_end_time | tsFormat('yyyy/MM/dd') }}（</span>
          <template v-if="course.valid_end_days > 2">
            <span>还有</span>
            <span class="days">{{ course.valid_end_days }}</span>
            <span>天</span>
          </template>
          <span class="days" v-else-if="course.valid_end_days == 0" style="margin: 0"> 今天 </span>
          <span class="days" v-else-if="course.valid_end_days == 1" style="margin: 0"> 明天 </span>
          <span class="days" v-else-if="course.valid_end_days == 2" style="margin: 0"> 后天 </span>
          <span>到期）</span>
        </template>
      </template>
    </span>
    <template v-else-if="course.valid_end_time >= 0 && !isValid">
      {{ course.valid_end_time | tsFormat('yyyy/MM/dd') }}截止
    </template>
    <template v-else>
      <span v-if="course.valid_type == 1">长期有效</span>
      <span v-else-if="course.valid_type == 2">
        {{ course.valid_time | tsFormat('yyyy/MM/dd') }}截止
      </span>
      <span v-else-if="course.valid_type == 3">{{ course.valid_time }}天</span>
      <TooltipEx
        v-if="course.valid_type != 1"
        class="tooltipex"
        contentClass="tooltip-help"
        :delay="0"
      >
        <img class="help" src="@/assets/images/course/help@2x.png" />
        <template v-slot:content>
          {{
            course.valid_type == 2
              ? '购买后，在此日期前，学员可进行学习'
              : '购买后，可持续学习的天数'
          }}
        </template>
      </TooltipEx>
    </template>
  </div>
</template>
<script>
import TooltipEx from '@/components/TooltipEx.vue';

export default {
  name: 'CourseShowValid',
  components: { TooltipEx },
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isValid() {
      return this.$services.CourseService.checkBuyValid(this.course);
    },
  },
};
</script>
<style lang="scss" scoped>
.valid {
  font-size: 14px;
  margin: 13px 0 19px 0;
  color: #999999;

  .days {
    color: #ff2d28;
    margin: 0 4px;
  }

  span {
    vertical-align: middle;
  }

  .tooltipex {
    display: inline-block;
    position: static;
    box-shadow: none;
    padding: 0;
    line-height: 1;
  }

  .help {
    width: 15px;
    height: 15px;
    vertical-align: middle;
    margin-left: 6px;

    .content {
      display: none;
    }
  }
}
</style>
<style lang="scss">
.tooltip-help {
  font-size: 14px;
}
</style>
